import React from "react";
import { Badge } from "./Badge";
import {
  getPostedStatusLabel,
  getStoredAccountingBackend,
} from "../../config/accounting";

type DocumentStatus = string;
type ReviewStatus = string;

interface StatusBadgeForCreditAndDebitNotesProps {
  status: DocumentStatus;
  reviewed?: ReviewStatus; // Optional, kept for compatibility but not used in logic
  type?: "credit" | "debit";
}

export const StatusBadgeForCreditAndDebitNotes: React.FC<
  StatusBadgeForCreditAndDebitNotesProps
> = ({ status, type = "credit" }) => {
  const postedLabel = getPostedStatusLabel(getStoredAccountingBackend());

  const getStatusBadgeVariant = (
    status: DocumentStatus
  ): "neutral" | "warning" | "success" | "error" => {
    if (status === "0" || status === "3") {
      return "warning";
    } else if (status === "1") {
      return "success";
    } else if (status === "2") {
      return "error";
    }
    return "neutral";
  };

  const getBadgeClassName = (status: DocumentStatus): string => {
    if (status === "1") {
      return "[&>span]:!text-success-800";
    }
    if (status === "2") {
      return "[&>span]:!text-error-600";
    }
    return "";
  };

  const getStatusLabel = (status: DocumentStatus): string => {
    if (status === "0" || status === "3") {
      return "Pending";
    } else if (status === "1") {
      return postedLabel;
    } else if (status === "2") {
      return "Rejected";
    }
    return "Unknown";
  };

  return (
    <Badge
      variant={getStatusBadgeVariant(status)}
      className={getBadgeClassName(status)}
    >
      {getStatusLabel(status)}
    </Badge>
  );
};
